import type {
  DayPart,
  PlanningEntityIdentifier,
  PlanningEntityType,
  TransportationMode
} from 'generated';

import { formatSecondsToHoursMinutes } from 'utils/date';

import DropIndicator from '../../components/DropIndicator/DropIndicator';
import type { PanelTheme } from '../../components/ActivityPanel/constants';
import { panelThemeColors } from '../../components/ActivityPanel/constants';
import { useIsColumnLoading } from '../ColumnLoadingContext';
import { useDropTarget } from '../hooks/useDropTarget';
import {
  DROP_INDICATOR_CLASS,
  DROPPABLE_ATTRIBUTE,
  RouteIcon,
  StyledTravelTime,
  TextContainer,
  TRAVEL_TIME_TEXT_CLASS
} from './TravelTimePragmatic.styles';

interface TravelTimePragmaticProps {
  id: string;
  dayPart: DayPart;
  scheduleStart: string;
  start: string;
  durationInSeconds: number;
  droppable: boolean | undefined;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
  transportationMode?: TransportationMode;
}

function TravelTimePragmatic({
  id: _id,
  dayPart = 'MORNING',
  droppable,
  scheduleStart,
  start,
  durationInSeconds,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier,
  transportationMode = 'CAR'
}: TravelTimePragmaticProps) {
  'use memo';
  const isColumnLoading = useIsColumnLoading();

  const ref = useDropTarget({
    scheduleStart,
    start,
    planningEntityType,
    planningEntityId,
    planningEntityIdentifier,
    canDrop: !!droppable && !isColumnLoading
  });

  const { textColor } = panelThemeColors[dayPart as PanelTheme];
  const isCarRoute = transportationMode === 'CAR';

  return (
    <StyledTravelTime
      component="li"
      ref={ref}
      className="traveltime-container"
      my={1}
      {...{ [DROPPABLE_ATTRIBUTE]: droppable ? '' : undefined }}
    >
      <DropIndicator className={DROP_INDICATOR_CLASS} />
      <TextContainer className={TRAVEL_TIME_TEXT_CLASS} color={textColor}>
        <RouteIcon
          type={isCarRoute ? 'car-side' : 'bicycle'}
          isCarRoute={isCarRoute}
        />
        {`${formatSecondsToHoursMinutes(durationInSeconds)} reistijd`}
      </TextContainer>
    </StyledTravelTime>
  );
}

export default TravelTimePragmatic;
